<template>
  <nav>
    <img src="@/assets/img.png" alt="Logo" style="height: 40px; margin-right: 20px;">
    <el-menu  class="el-menu-demo" mode="horizontal" default-active="1">
      <el-menu-item index="1" @click="$router.push('/HomeView')">员工管理</el-menu-item>
      <el-menu-item index="2" @click="$router.push('/Organization')">组织机构</el-menu-item>
      <el-menu-item index="3" @click="$router.push('/Visitor')">访客管理</el-menu-item>
      <el-menu-item index="4" @click="$router.push('/Appointment')">预约记录</el-menu-item>
      <el-menu-item index="5" >数据备份</el-menu-item>
      <el-menu-item index="6" >角色管理</el-menu-item>
      <el-menu-item index="7" @click="$router.push('/Config')">配置管理</el-menu-item>
    </el-menu>
    <span style="margin-left: 100px;">
        <el-link :underline="false" ><i class="el-icon-user">{{name}}</i></el-link>
      </span>
    <span style="margin-left: 50px" @click="out()">
        <el-link :underline="false"><i class="el-icon-right"></i>退出登录</el-link>
      </span>
  </nav>
</template>

<script>
export default {
  name: 'AboutView',
  data(){
    return {
      name:localStorage.getItem('userName')
    }
  },
  methods: {
    out(){
      const targetPath = `/Login`;
      this.$router.push(targetPath);
      localStorage.clear()
    }
  }
};
</script>

<style scoped>
nav {
  padding: 0 20px; /* 调整内边距以适应内容 */
  display: flex; /* 使用 Flexbox 来布局菜单项 */
  align-items: center; /* 垂直居中菜单项（如果需要） */
  /* 可能需要更多的样式来适应您的设计 */
}
</style>